import React from 'react'
import { MicroFrontEnd } from 'properties-ui-common'
import apiConfig from '../../../apiConfig'
import { mfeNavUrls } from '../utility/url'
import { TgtLogger } from '@measurement/opentelemetry-web'

export const IndirectItemMultiDocDownload = () => {
  return (
    <MicroFrontEnd
      name="IndirectItemMultiDocDownload"
      src={apiConfig.microFrontEnds.IndirectItemMultiDocDownload}
      props={{
        mfeNavUrls,
      }}
      useErrorBoundary
      logger={TgtLogger}
    />
  )
}
export default IndirectItemMultiDocDownload
